export function transformErrorToObject(err) {
    var _a;
    var _b = err.message.split('//'), _ = _b[0], type = _b[1], message = _b[2];
    return _a = {}, _a[type] = message, _a;
}
